{
  "RTS": "https://www.rts.ch/entreprise/drm/9959798-la-ssr-adopte-le-cryptage-numerique.html",
  "SRF": "https://www.srf.ch/hilfe/website-und-apps/digitale-verschluesselung",
  "RTR": "https://www.rtr.ch/drm",
  "RSI": "https://www.rsi.ch/chi-siamo/mestieri/La-SSR-introduce-la-codifica-digitale-11038056.html",
  "SWI": ""
}
